export enum TaskStatusUpdateValue {
  Release = 'Release',
  Complete = 'Complete',
  ResetComplete = 'Reset Complete',
}
